import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-score',
    templateUrl: './score.component.html',
    styleUrls: ['./score.component.scss'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(500, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate(1000, style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: true,
    imports: [NgIf, FaIconComponent]
})
export class ScoreComponent implements OnChanges {

  @Input()
  score?: number ;

  @Input()
  percent?: boolean ;

  health?: number ;
  armour?: number ;

  scoreDelta?: number ;
  scoreDeltaTimeout?: NodeJS.Timeout ;


  get hasScore(): boolean {
    return this.score != undefined ;
  }

  get formattedDelta(): string {

    if (this.scoreDelta === undefined) {
      return "";
    }

    let str = "" + this.scoreDelta ;
    if (this.scoreDelta > 0)
      str = '+' + str ;

    return str ;
  }

  get colorClass(): string {

    if (this.scoreDelta === undefined) {
      return "";
    }

    if (this.scoreDelta > 0)
      return "positive-score" ;
    else if (this.scoreDelta < 0)
      return "negative-score" ;
    else
      return "text-gray-400" ;
  }

  get healthClass(): string {

    if (this.health == undefined) {
      return 'text-muted'
    }

    if (this.health < 100) {
      return 'text-negative'
    } else {
      return 'text-positive'
    }
  }

  get armourClass(): string {
    if (!this.armour) {
      return 'text-muted'
    } else {
      return 'text-yellow-200'
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    const scoreChange = changes['score'] ;

    if (this.percent) {

      if (scoreChange.currentValue == null) {
        this.health = undefined ;
        this.armour = undefined ;
      } else {

        const val = Math.round(scoreChange.currentValue * 100) ;

        if (val < 100) {
          this.health = val ;
          this.armour = 0 ;
        } else {
          this.health = 100 ;
          this.armour = val - 100 ;
        }
      }

      return ;
    }


    if (!scoreChange || scoreChange.isFirstChange())
      return ;

    if (scoreChange.previousValue == undefined || scoreChange.currentValue == undefined)
      return ;

    if (scoreChange.currentValue == scoreChange.previousValue)
      return ;

    this.scoreDelta = scoreChange.currentValue - scoreChange.previousValue ;
    //if (this.percent) {
    //  this.scoreDelta = Math.round(this.scoreDelta * 100) ;
    //}

    if (this.scoreDeltaTimeout)
      clearTimeout(this.scoreDeltaTimeout);

    this.scoreDeltaTimeout = setTimeout(()=>{ this.scoreDelta = undefined }, 2000);
  }

}
